import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 53D302C9-3A0D-4104-967E-21D174E3C0B2
 * name chevron-double-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-double-up.svg
 * tags
 * - Arrow 
 */
export const ChevronDoubleUpIcon = createSvgIcon(<><path d="M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z" /></>, 'ChevronDoubleUpIcon');
export default ChevronDoubleUpIcon